import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-around" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between me-3" }
const _hoisted_3 = { class: "info-box" }
const _hoisted_4 = { class: "info-box" }

import { computed } from 'vue';
import { formatNumber, toDate } from '@/utils/helpers';
import MintCountdown from '@/components/MintCountdown.vue';
import * as anchor from '@project-serum/anchor';
import { CandyMachineState, MintStatus } from '@/utils';

export interface CandyMachineAccount {
  id: anchor.web3.PublicKey;
  program: anchor.Program;
  state: CandyMachineState;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MintInfo',
  props: ['candyMachine'],
  setup(__props) {

const props = __props


const mintStatus = computed(() =>
  !props.candyMachine?.state?.isActive || props.candyMachine?.state?.isSoldOut
    ? MintStatus.COMPLETED
    : props.candyMachine?.state.isPresale
    ? MintStatus.PRESALE
    : MintStatus.LIVE
);

const getMintPrice = (candyMachine: CandyMachineAccount): string => {
  const price = formatNumber.asNumber(
    candyMachine.state.isPresale
      ? candyMachine.state.whitelistMintSettings?.discountPrice!
      : candyMachine.state.price!
  );
  return `◎ ${price}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Remaining: " + _toDisplayString(props.candyMachine.state.itemsRemaining), 1),
      _createElementVNode("span", _hoisted_4, "Price: " + _toDisplayString(getMintPrice(props.candyMachine)), 1),
      _createVNode(MintCountdown, {
        time: 
          _unref(toDate)(
            props.candyMachine?.state.goLiveDate
              ? props.candyMachine?.state.goLiveDate
              : props.candyMachine?.state.isPresale
              ? new anchor.BN(new Date().getTime() / 1000)
              : undefined
          )
        ,
        status: 
          !props.candyMachine?.state?.isActive ||
          props.candyMachine?.state?.isSoldOut
            ? 'COMPLETED'
            : props.candyMachine?.state.isPresale
            ? 'PRESALE'
            : 'LIVE'
        
      }, null, 8, ["time", "status"])
    ])
  ]))
}
}

})